import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation RenderDesignerContactEmailMutation($input: RenderDesignerContactEmailInput!) {
        renderDesignerContactEmail(input: $input) {
            clientMutationId
        }
    }
`;

const commit = (environment, args) => {
    const { message, recipientEmails, senderEmail, senderName, onCompleted, onError } = args;

    const input = { message, recipientEmails, senderEmail, senderName };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
